module.exports = __webpack_public_path__ + "static/worldpatientsafety-0cc2a8f15c4827cb214fd4e92683b7bc.png";